import { Flow } from "../types";
import { SCREENS } from "../screens";
import { Contract } from "@/types/contract";
import { shouldCollectGDPRAgreements } from "@/utils/contract";
import { showAttachmentsScreen } from "../helpers";

export const ASSISTED_SALES: Flow = {
  [SCREENS.WELCOME]: {
    next: (contract: Contract) => {
      return showAttachmentsScreen(contract) ? SCREENS.ATTACHMENTS : SCREENS.RECAPITULATION;
    },
    back: () => null,
  },
  [SCREENS.ATTACHMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.WELCOME,
  },
  [SCREENS.CUSTOMER]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.PAYMENTS]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.PRODUCTION_POINT]: {
    next: () => SCREENS.RECAPITULATION,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.RECAPITULATION]: {
    next: (contract: Contract, options?: { gdprAgreed?: boolean; isContractRequest?: boolean }) =>
      !options?.gdprAgreed && shouldCollectGDPRAgreements(contract, options?.isContractRequest ?? false)
        ? SCREENS.AGREEMENTS
        : SCREENS.VIEW,
    back: (contract: Contract) => {
      return showAttachmentsScreen(contract) ? SCREENS.ATTACHMENTS : SCREENS.WELCOME;
    },
  },
  [SCREENS.AGREEMENTS]: {
    next: () => SCREENS.VIEW,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.VIEW]: {
    next: () => SCREENS.SIGNATURE,
    back: () => SCREENS.RECAPITULATION,
  },
  [SCREENS.SIGNATURE]: {
    next: () => SCREENS.SMS_CODE,
    back: () => SCREENS.VIEW,
  },
  [SCREENS.SIGNATURE_ON_PHONE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => null,
  },
  [SCREENS.SMS_CODE]: {
    next: () => SCREENS.THANK_YOU,
    back: () => SCREENS.SIGNATURE,
  },
  [SCREENS.THANK_YOU]: {
    next: () => null,
    back: () => null,
  },
};
